import { CREATE_INITIATIVE_PANEL_OPEN, CREATE_INITIATIVE_PANEL_CLOSE } from 'actions/actionTypes';

export const openCreateInitiativePanelAction = ({
  onClose,
  onCancel,
  onSave,
  selectedTimeBoundPeriod,
  baseKR,
  team,
  ownerEmployee, // default owner employee
  subObjective, // default selected Objective.
  actionDispatchSource = '',
  panelHeaderText = '',
}) => ({
  type: CREATE_INITIATIVE_PANEL_OPEN,
  payload: {
    onClose,
    onCancel,
    onSave,
    team,
    selectedTimeBoundPeriod,
    baseKR,
    ownerEmployee,
    subObjective,
    actionDispatchSource,
    panelHeaderText,
  },
});

export const closeCreateInitiativePanelAction = () => ({ type: CREATE_INITIATIVE_PANEL_CLOSE });
